import ExternalLinksBaseHandler from '../external_links_base_handler';
import {MEMBERSHIP_POST_ACTIONS, REGISTRATION_DATA_KEY} from './external_links_membership_handler_consts';
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import {POST_ACTIONS} from '../../../../events/post_actions';
import {CASHIER_ACTIONS, GNWP_SOURCES} from '../../external_links_consts';
import ServiceFactory from '../../../../services/service_factory';
import Device from "../../../../utils/device";
import Store from "../../../../utils/store";

/**
 *
 */
class ExternalLinkMembershipHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinkMembershipHandler';
    static HandlerName = 'membership';

    /**
     * Override base class onBtnCloseClicked
     * Handle overlay close button click event
     * Send event to b2c when user is finished a registration
     */
    onBtnCloseClicked() {
        super.onBtnCloseClicked();
        if (ServiceFactory.create().oAuth2Service().isAuthorized()) {
            Event.fire(SYSTEM_EVENTS.PLAYER_ACTION, {
                source: this.HandlerName,
                actionName: POST_ACTIONS.REGISTRATION_COMPLETED
            });
        }
    }


    getHandlerName() {
        return ExternalLinkMembershipHandler.HandlerName;
    }


    /**
     * Overrides base class
     * @param postMessageData
     */
	executePostMessageAction(postMessageData) {
        switch (postMessageData.ActionId.toString()) {
            case MEMBERSHIP_POST_ACTIONS.PLAY:
                if (!this.componentControllerRef.getIsHasActionCallback()) {
                    Event.fire(SYSTEM_EVENTS.PLAYER_ACTION, {
                        source: ExternalLinkMembershipHandler.HandlerName,
                        actionName: POST_ACTIONS.PLAY
                    });
                }
                this.close(POST_ACTIONS.PLAY);
                break;
            case MEMBERSHIP_POST_ACTIONS.DEPOSIT:
                if (!this.componentControllerRef.getIsHasActionCallback()) {
                    Event.fire(SYSTEM_EVENTS.PLAYER_ACTION, {
                        source: ExternalLinkMembershipHandler.HandlerName,
                        actionName: POST_ACTIONS.DEPOSIT
                    });
                }
                this.close(POST_ACTIONS.DEPOSIT);
                break;
            case MEMBERSHIP_POST_ACTIONS.BACK:
                this.close();
                break;
            case MEMBERSHIP_POST_ACTIONS.UPLOAD_DOCUMENTS_CASHIER:
                // Post Action is not supported in case of Upload Documents,
                // So if this action received, the user should be redirected to cashier anyway and post action (deeplink) will be terminated
                Event.fire(SYSTEM_EVENTS.PLAYER_ACTION, {
                    source: ExternalLinkMembershipHandler.HandlerName,
                    actionName: POST_ACTIONS.DEPOSIT,
                    options: {sessionType: Device.isMobile() ? CASHIER_ACTIONS.MOBILE_VERIFY_ID : CASHIER_ACTIONS.VERIFY_ID}
                });
                this.close(POST_ACTIONS.CLOSE);
                break;
            case MEMBERSHIP_POST_ACTIONS.SHOW_LOGIN:
                //Close membership window and open login
                this.close(POST_ACTIONS.CLOSE);
                ServiceFactory.create().webLoginService().openLoginForm();
                break;
            case MEMBERSHIP_POST_ACTIONS.REGISTRATION_COMPLETED:
                Event.fire(SYSTEM_EVENTS.REGISTRATION_COMPLETED, postMessageData);
                break;
            case MEMBERSHIP_POST_ACTIONS.OPEN_BANK_ID:
                ServiceFactory.create().windowService().openBankId(postMessageData.AppUrl);
                break;
            case MEMBERSHIP_POST_ACTIONS.DOWNLOAD_APP:
                ServiceFactory.create().windowService().redirect(ServiceFactory.create().skinService().getAppDownloadPageURL());
                break;
            case MEMBERSHIP_POST_ACTIONS.STORE_REGISTRATION_COOKIES_DATA:
                if(postMessageData && postMessageData.StoreRegistrationCookiesData) {
                    Store.set(REGISTRATION_DATA_KEY, JSON.stringify(postMessageData.StoreRegistrationCookiesData));
                }
                break;
            case MEMBERSHIP_POST_ACTIONS.UPLOAD_DOCUMENTS_IV:
                this.close(POST_ACTIONS.CLOSE);
                ServiceFactory.create().openLinkService().openLink({source: GNWP_SOURCES.DOCUMENT_UPLOAD});
                break;
            default:
                this.logger.warn('Not supported ActionID. ActionID = ' + postMessageData.ActionId);
                break;
        }
    }
}

export default ExternalLinkMembershipHandler;